import { useFetch } from 'utils/sdk.ts';
import { SWRConfiguration } from 'swr';

export enum PaymentStatusEnum {
  PENDING = 'pending',
  FAILED = 'failed',
  CANCELED = 'canceled',
  EXPIRED = 'expired',
  PAID = 'paid',
}

interface StatusDto {
  status: PaymentStatusEnum;
}

export const useProcessingPayment = (paymentId?: number | string, config?: SWRConfiguration) =>
  useFetch<StatusDto>(paymentId ? `api/customer-facing/flight-ticket-payment-status/${paymentId}/` : null, config);
